import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function services() {
    return {
        index,
        get,
        create,
        update,
        remove
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`adservice/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`adservice/get?id=${id}`);
    }

    function create(data) {
        return axiosInstance.post('adservice/create', data);
    }

    function update(data) {
        return axiosInstance.patch('adservice/update', data);
    }

    function remove(id) {
        return axiosInstance.delete(`adservice/delete`, {
            data: {
                id
            }
        });
    }
}
